import {
  SAVE_REQUESTS_LIST,
  SAVE_REQUEST_DETAILS
} from 'redux/constants/Requests';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_REQUESTS_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_REQUEST_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme